import React from 'react'
import { Button } from 'react-bootstrap'
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons'
import useMonth from './use-month'

const MonthSelector = ({
    disabled,

    month,
    onMonthChange = () => {},
    year,
    onYearChange = () => {},
}) => {

    const { date, onLeftClick, onRightClick } = useMonth({ month, year, onMonthChange, onYearChange })

    return (
        <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'space-between'}}>
            <Button
                variant='link'
                disabled={disabled}
                onClick={onLeftClick}
            >
                <ChevronLeft />
            </Button>
            <div
                style={{ flexGrow: '1' }} 
                className='align-self-center text-center text-muted'
            >
                {date.format('MMMM YYYY')}
            </div>
            <Button
                variant='link'
                disabled={disabled}
                onClick={onRightClick}
            >
                <ChevronRight />
            </Button>
        </div>
    )
}

export default MonthSelector